import React from 'react';
import Logo from '../../assets/images/oneGlobeLogo.png';
import LogoDark from '../../assets/images/oneGlobeLogoDark.png';
import { Link } from 'react-router-dom';

export type FooterProps = {
  displayNav: boolean;
};

const Footer: React.FC<FooterProps> = ({ displayNav }) => {
  const logoImg = (
    <>
      <img className="h-4 lg:h-6 dark:hidden" src={Logo} alt="OneGlobe Logo" />
      <img className="h-4 lg:h-6 hidden dark:block" src={LogoDark} alt="OneGlobe Logo" />
    </>
  );

  return (
    <footer className="mt-auto bg-(--color-surface-bold) py-8 text-(--color-text-primary)">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <div>{displayNav ? <Link to="/">{logoImg}</Link> : logoImg}</div>
          <p className="text-xs uppercase text-(--color-text-muted)">
            Copyright &copy; 2025 OneGlobe. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
